import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('box/user/backupsetings');
}

const updateAutoAdd = ({seatType, autoAdd}) => {
  return POST('box/user/backupsetings', {
    seatType, autoAdd
  })
}


export {
  list,
  updateAutoAdd
}
